import { theme } from "aaa";
import { DynamicFontTextfield } from "components/util/DynamicFontTextfield";
import { ui } from "components/util/uiHelpers";
import { config } from "config";
import * as React from "react";
import { amountToCurrencyString, numberToEuroAmount } from "types/amount";
import { IAmount } from "types/fee";

export const DynamicAmountTextField = ({ onChange, value, maxAmount, disabled }: { onChange: (amount: IAmount) => void, value: IAmount, maxAmount?: number, disabled?: boolean }) => {
    const [amountString, setAmountString] = React.useState("");

    const handleChange = (_: any, inputValue: string) => {
        const cleanedString = inputValue
            .split(config.CURRENCY_THOUSANDS_SEPARATOR).join("")
            .replace("€", "")
            .replace(config.CURRENCY_DECIMAL_SEPARATOR, ".");

        const cleanedAmount = Number(cleanedString);

        if (!isNaN(cleanedAmount)) {
            if (maxAmount !== undefined && cleanedAmount > maxAmount) {
                return;
            }
            setAmountString(cleanedAmount.toString().replace(".", config.CURRENCY_DECIMAL_SEPARATOR));
            onChange(numberToEuroAmount(cleanedAmount));
        }
    };

    const handleFocus = () => {
        handleChange(undefined, amountString ? amountString : amountToCurrencyString(value));
    };

    const handleBlur = () => {
        setAmountString("");
    };

    return (
        <DynamicFontTextfield
            onChange={handleChange}
            value={amountString ? amountString : amountToCurrencyString(value).replace("€", "")}
            onFocus={handleFocus}
            onBlur={handleBlur}
            disabled={disabled}
            onKeyPress={(event: any) => {
                if (event.key === "Enter") {
                    setAmountString("");
                    event.target.blur();
                    event.preventDefault();
                }
            }}
            inputStyle={{ fontSize: 40, fontWeight: 700, color: ui.isDarkMode ? "white" : theme.themeColors.blue_400, textAlign: "center" }}
        />
    );
};


// WEBPACK FOOTER //
// ./src/components/common/DynamicAmountTextField.tsx